import { useState } from "react";
import Modal from "@components/ModalTemplate";
import Button from "@components/Button";
import { useNavigate } from "react-router-dom";
import "./style.scss";

export default function UltraInsiderInfoModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const steps = [
    { number: "1", text: <>Exklusive Rabattgutscheine</> },
    {
      number: "2",
      text: (
        <>Ausgewählte Aktivitäten, Events und&nbsp;sammelbare&nbsp;Badges</>
      ),
    },
    { number: "3", text: <>Bonuspunkte für Aktivitäten und Stories</> },
  ];

  const handleDiscoverClick = async () => {
    onClose();
    await document
      .querySelector("body")
      .classList.remove("ReactModal__Body--open");
    await navigate("/ultra-insider");
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleDiscoverClick}
      disableClose={false}
      innerClass="ultra-insider-info-modal"
    >
      <div className="content-wrapper">
        <div className="image-wrapper"></div>
        <div className="top-content">
          <strong>Neuer Bereich</strong>
          <br /> voller exklusiver Vorteile!
        </div>
        <div className="steps">
          <div className="steps-body">
            <h4 className="steps-title">
              <strong>Ultra Space</strong> ist jetzt da — <br />
              <span className="steps-subtitle"> und randvoll mit Extras:</span>
            </h4>

            {steps.map((step, index) => (
              <div className="step" key={index}>
                <div className="step-number"></div>
                <div className="step-text">{step.text}</div>
              </div>
            ))}
          </div>
          <p className="bottom-content">
            Jetzt ist deine Zeit gekommen, weiterzugehen und ein Ultra Insider
            zu werden!
          </p>

          <Button action={handleDiscoverClick}>Jetzt Entdecken</Button>
        </div>
      </div>
    </Modal>
  );
}
